<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="!loader">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <strong>Note : If any data is not available or applicable, kindly mention NA, for numeric field type 0 </strong>
      <v-form id="familydetails_form" @submit.prevent="submit" v-model="isValid" v-if="loader">
          <v-row dense justify="center">
              <v-col cols="10" sm="10" md="10">
                  <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" />

                  <v-row dense justify="center" v-if="form_who_takes_pupil_studies != null">
                      <v-col cols="10" sm="10" md="10">
                          <v-icon color="error" v-if="form_who_takes_pupil_studies">*</v-icon>
                          <v-text-field
                              dense
                              v-model="who_takes_pupil_studies"
                              name="who_takes_pupil_studies"
                              :required="form_who_takes_pupil_studies"
                              :rules="
                form_who_takes_pupil_studies
                  ? [(v) => !!v || 'Please enter required data']
                  : []
              "
                              :clearable="form_who_takes_pupil_studies ? false : true"
                              :prepend-icon="
                form_who_takes_pupil_studies != null
                  ? 'mdi-account-circle'
                  : 'mdi-account-circle-outline'
              "
                              outlined
                              hint="Members of the family who are able to supervise the pupil's studies at home"
                              persistent-hint
                          ></v-text-field>
                      </v-col>
                  </v-row>

                  <!--  Father Details --------------------------------------------->
              </v-col>
          </v-row>
          <input v-if="relative_father_details" type="hidden" value="Father" name="relation_type" />
          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <h4>*{{ relative_father_details.field_display_name }} [Please fill all available data]</h4>
              </v-col>
          </v-row>
          <!-- {{form_relative_details}} -->
          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_full_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_full_name"
                      name="father_full_name"
                      :required="form_relative_details.father_full_name_sbpps"
                      :rules="
            form_relative_details.father_full_name_sbpps
              ? [(v) => !!v || 'Father full name is required']
              : []
          "
                      :clearable="form_relative_details.father_full_name_sbpps ? false : true"
                      :prepend-icon="
            relative_father_details.relative_full_name != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Full Name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_father_details!= null"> 
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_contact_no_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="number"
                      v-model="relative_father_details.relative_contact_no"
                      name="father_contact_no"
                      :required="form_relative_details.father_contact_no_sbpps"
                      :rules="
            form_relative_details.father_contact_no_sbpps
              ? [
                  (v) => !!v || 'Mobile Number is required',
                  (v) =>
                    (v && v.length == 10) || 'Mobile Number Must be 10 digit',
                ]
              : [
                  (v) =>
                    (v == null || v == ''
                      ? true
                      : v.length == 0 || v.length == 10) ||
                    'Mobile Mobile Number Must be 10 digit',
                ]
          "
                      counter
                      maxlength="10"
                      hint="Mobile No."
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.father_contact_no_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_contact_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_father_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_phone_no"
          >*</v-icon
        >
        <v-text-field
          dense
          type="number"
          v-model="relative_father_details.relative_phone_no"
          name="father_phone_no"
          :required="form_relative_details.relative_phone_no"
          counter
          hint="Phone/Landline No."
          persistent-hint
          single-line
          outlined
          :clearable="
            form_relative_details.relative_phone_no ? false : true
          "
          :prepend-icon="
            relative_father_details.relative_phone_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
        ></v-text-field>
      </v-col>
    </v-row> -->
          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_email_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_father_details.relative_email"
                      name="father_email"
                      :required="form_relative_details.father_email_sbpps"
                      :rules="
            form_relative_details.father_email_sbpps
              ? [
                  (v) => !!v || 'Email is required',
                  (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                ]
              : [
                  (v) =>
                    v == null ||
                    v == '' ||
                    /.+@.+/.test(v) ||
                    'E-mail must be valid',
                ]
          "
                      counter
                      hint="Email"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="form_relative_details.father_email_sbpps ? false : true"
                      :prepend-icon="
            relative_father_details.relative_email != null
              ? 'mdi-email'
              : 'mdi-email'
          "
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_aadharno_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_aadharno"
                      name="father_aadharno"
                      :required="form_relative_details.father_aadharno_sbpps"
                      :rules="
                      form_relative_details.father_aadharno_sbpps.required
                        ? [
                            v => !!v || 'Aadhaar No is required',
                            v =>
                              (v && v.length == 12) ||
                               'Aadhaar no must be 12 digit number'
                          ]
                        : [
                            v =>
                              (v == null || v == ''
                                ? true
                                : v.length == 0 || v.length == 12) ||
                              'Aadhaar no must be 12 digit number'
                          ]
                    "
                    counter
                    maxlength="12"
                      :clearable="form_relative_details.father_aadharno_sbpps ? false : true"
                      :prepend-icon="
            relative_father_details.relative_aadharno != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Aadhaar Card No."
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <!-- <v-row dense justify="center" v-if="relative_father_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_citizenship"
          >*</v-icon
        >
        <v-text-field
          dense
          v-model="relative_father_details.relative_citizenship"
          name="father_citizenship"
          :required="form_relative_details.relative_citizenship"
          :rules="
            form_relative_details.relative_citizenship
              ? [(v) => !!v || 'Father aadharno is required']
              : []
          "
          :clearable="form_relative_details.relative_citizenship ? false : true"
          :prepend-icon="
            relative_father_details.relative_citizenship != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
          outlined
          hint="Citizenship."
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row> -->

          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_nationality_sbpps">*</v-icon>
                  <v-autocomplete
                      dense
                      v-model="relative_father_details.relative_nationality"
                      :items="nationality_list"
                      name="father_nationality"
                      :required="form_relative_details.father_nationality_sbpps"
                      :clearable="
            form_relative_details.father_nationality_sbpps ? false : true
          "
                      return-object
                      single-line
                      :prepend-icon="
            relative_father_details.relative_nationality != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Nationality"
                      persistent-hint
                  ></v-autocomplete>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_education_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_education"
                      name="father_education"
                      :required="form_relative_details.father_education_sbpps"
                      :rules="
            form_relative_details.father_education_sbpps
              ? [(v) => !!v || 'Education field is required']
              : []
          "
                      :clearable="form_relative_details.father_education_sbpps ? false : true"
                      :prepend-icon="
            relative_father_details.relative_education != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Qualification"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          

          <v-row dense justify="center" v-if="relative_father_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_occupation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_father_details.relative_occupation"
                      name="father_occupation"
                      :required="form_relative_details.father_occupation_sbpps"
                      :rules="form_relative_details.father_occupation_sbpps? [(v) => !!v || ' Occupation is required']: []"
                      counter
                      hint="Occupation"
                      persistent-hint
                      single-line
                      outlined
                      :prepend-icon="relative_father_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"
                  ></v-text-field>

                  <!-- <v-autocomplete
          dense
          v-model="relative_father_details.relative_occupation"
          :items="occupation_list"
          name="father_occupation"
          :required="form_relative_details.relative_occupation"
          :rules="
            form_relative_details.relative_occupation
              ? [(v) => !!v || ' Occupation is required']
              : []
          "
          :clearable="
            form_relative_details.relative_occupation ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_father_details.relative_occupation != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select Occupation"
          persistent-hint
        ></v-autocomplete> -->
              </v-col>
          </v-row>
            <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_department_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_department"
                      name="father_department"
                      :required="form_relative_details.father_department_sbpps"
                      :rules="
            form_relative_details.father_department_sbpps
              ? [(v) => !!v || 'Department is required']
              : []
          "
                      :clearable="
            form_relative_details.father_department_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_department != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Department"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_designation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_designation"
                      name="father_designation"
                      :required="form_relative_details.father_designation_sbpps"
                      :rules="
            form_relative_details.father_designation_sbpps
              ? [(v) => !!v || 'Designation is required']
              : []
          "
                      :clearable="
            form_relative_details.father_designation_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_designation != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Designation"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_organization_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_organization_name"
                      name="father_organization_name"
                      :required="form_relative_details.father_organization_name_sbpps"
                      :rules="
            form_relative_details.father_organization_name_sbpps
              ? [(v) => !!v || 'Company/Organization name is required']
              : []
          "
                      :clearable="
            form_relative_details.father_organization_name_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_organization_name != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Company/Organization"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_income_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_father_details.relative_income"
                      name="father_income"
                      type="number"
                      :required="form_relative_details.father_income_sbpps"
                      :clearable="form_relative_details.father_income_sbpps ? false : true"
                      :prepend-icon="
            relative_father_details.relative_income != null
              ? 'mdi-alpha-c-circle'
              : 'mdi-alpha-c-circle-outline'
          "
                      outlined
                      hint="Annual Income"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row> -->
           <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_income_range_sbpps">*</v-icon>
               <v-autocomplete
                      dense
                      :items="salaryRanges"
                      item-text="name"
                      v-model="relative_father_details.relative_income_range"
                      name="father_income_range"
                      :required="form_relative_details.father_income_range_sbpps"
                      :clearable="form_relative_details.father_income_range_sbpps ? false : true"
                      :prepend-icon="
                      relative_father_details.relative_income_range != null
                        ? 'mdi-alpha-c-circle'
                        : 'mdi-alpha-c-circle-outline'
                    "
                      outlined
                      hint="Annual Income"
                      persistent-hint
                ></v-autocomplete>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_father_details!= null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_office_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_father_details.relative_office_address"
                      :value="relative_father_details.relative_office_address"
                      name="father_office_address"
                      :required="form_relative_details.father_office_address_sbpps"
                      :rules="
            form_relative_details.father_office_address_sbpps
              ? [(v) => !!v || 'Office Address is required']
              : []
          "
                      hint="Company/Organization Address & Contact details"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.father_office_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_office_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="form_relative_details.father_local_address_sbpps">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_local_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_father_details.relative_local_address"
                      :value="relative_father_details.relative_local_address"
                      name="father_local_address"
                      :required="form_relative_details.father_local_address_sbpps"
                      :rules="
            form_relative_details.father_local_address_sbpps
              ? [(v) => !!v || 'Local Address is required']
              : []
          "
                      hint="Local Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.father_local_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_local_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="form_relative_details.father_permanent_address_sbpps">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.father_permanent_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_father_details.relative_permanent_address"
                      :value="relative_father_details.relative_permanent_address"
                      name="father_permanent_address"
                      :required="form_relative_details.father_permanent_address_sbpps"
                      :rules="
            form_relative_details.father_permanent_address_sbpps
              ? [(v) => !!v || 'Permanent Address is required']
              : []
          "
                      hint="Permanent Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.father_permanent_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_father_details.relative_permanent_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>

          <!-- <v-row dense justify="center" v-if="relative_father_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_state"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_father_details.relative_state"
          :items="state_list"
          name="father_state"
          :required="form_relative_details.relative_state"
          :rules="
            form_relative_details.relative_state
              ? [(v) => !!v || ' State is required']
              : []
          "
          :clearable="
            form_relative_details.relative_state ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_father_details.relative_state != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select State"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row>
     <v-row dense justify="center" v-if="relative_father_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_city"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_father_details.relative_city"
          :items="cities_list"
          name="father_city"
          :required="form_relative_details.relative_city"
          :rules="
            form_relative_details.relative_city
              ? [(v) => !!v || ' City is required']
              : []
          "
          :clearable="
            form_relative_details.relative_city ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_father_details.relative_city != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select City"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row> -->

        

          <hr color="grey lighten-1" v-if="relative_mother_details" />
          <!-- End Father Details --------------------------------------------->

          <!-- Mother Details --------------------------------------------->

          <input v-if="relative_mother_details" type="hidden" value="Mother" name="relation_type" />
          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <h4>*{{ relative_mother_details.field_display_name }} [Please fill all available data]</h4>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_full_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_full_name"
                      name="mother_full_name"
                      :required="form_relative_details.mother_full_name_sbpps"
                      :rules="
            form_relative_details.mother_full_name_sbpps
              ? [(v) => !!v || 'Mother full name is required']
              : []
          "
                      :clearable="form_relative_details.mother_full_name_sbpps ? false : true"
                      :prepend-icon="
            relative_mother_details.relative_full_name != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Full Name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_contact_no_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="number"
                      v-model="relative_mother_details.relative_contact_no"
                      name="mother_contact_no"
                      :required="form_relative_details.mother_contact_no_sbpps"
                      :rules="
            form_relative_details.mother_contact_no_sbpps
              ? [
                  (v) => !!v || 'Mobile Number is required',
                  (v) =>
                    (v && v.length == 10) || 'Mobile Number Must be 10 digit',
                ]
              : [
                  (v) =>
                    (v == null || v == ''
                      ? true
                      : v.length == 0 || v.length == 10) ||
                    'Mobile Mobile Number Must be 10 digit',
                ]
          "
                      counter
                      maxlength="10"
                      hint="Mobile No."
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.mother_contact_no_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_contact_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
                  ></v-text-field>
              </v-col>
          </v-row>

          <!-- <v-row dense justify="center" v-if="relative_mother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_phone_no"
          >*</v-icon
        >
        <v-text-field
          dense
          type="number"
          v-model="relative_mother_details.relative_phone_no"
          name="mother_phone_no"
          :required="form_relative_details.relative_phone_no"
          counter
          hint="Phone /Landline No."
          persistent-hint
          single-line
          outlined
          :clearable="
            form_relative_details.relative_phone_no ? false : true
          "
          :prepend-icon="
            relative_mother_details.relative_phone_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
        ></v-text-field>
      </v-col>
    </v-row> -->

          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_email_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_mother_details.relative_email"
                      name="mother_email"
                      :required="form_relative_details.mother_email_sbpps"
                      :rules="
            form_relative_details.mother_email_sbpps
              ? [
                  (v) => !!v || 'Email is required',
                  (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                ]
              : [
                  (v) =>
                    v == null ||
                    v == '' ||
                    /.+@.+/.test(v) ||
                    'E-mail must be valid',
                ]
          "
                      counter
                      hint="Email"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="form_relative_details.mother_email_sbpps ? false : true"
                      :prepend-icon="
            relative_mother_details.relative_email != null
              ? 'mdi-email'
              : 'mdi-email'
          "
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_aadharno_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_aadharno"
                      name="mother_aadharno"
                      :required="form_relative_details.mother_aadharno_sbpps"
                      :rules="
                      form_relative_details.mother_aadharno_sbpps.required
                        ? [
                            v => !!v || 'Aadhaar No is required',
                            v =>
                              (v && v.length == 12) ||
                               'Aadhaar no must be 12 digit number'
                          ]
                        : [
                            v =>
                              (v == null || v == ''
                                ? true
                                : v.length == 0 || v.length == 12) ||
                              'Aadhaar no must be 12 digit number'
                          ]
                    "
                    counter
                    maxlength="12"
                      :clearable="form_relative_details.mother_aadharno_sbpps ? false : true"
                      :prepend-icon="
            relative_mother_details.relative_aadharno != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Aadhaar Card No."
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_mother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_citizenship"
          >*</v-icon
        >
        <v-text-field
          dense
          v-model="relative_mother_details.relative_citizenship"
          name="mother_citizenship"
          :required="form_relative_details.relative_citizenship"
          :rules="
            form_relative_details.relative_citizenship
              ? [(v) => !!v || 'Mother Citizenship is required']
              : []
          "
          :clearable="form_relative_details.relative_citizenship ? false : true"
          :prepend-icon="
            relative_mother_details.relative_citizenship != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
          outlined
          hint="Citizenship."
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row> -->

          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_nationality_sbpps">*</v-icon>
                  <v-autocomplete
                      dense
                      v-model="relative_mother_details.relative_nationality"
                      :items="nationality_list"
                      name="mother_nationality"
                      :required="form_relative_details.mother_nationality_sbpps"
                      :clearable="
            form_relative_details.mother_nationality_sbpps ? false : true
          "
                      return-object
                      single-line
                      :prepend-icon="
            relative_mother_details.relative_nationality != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Nationality"
                      persistent-hint
                  ></v-autocomplete>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_education_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_education"
                      name="mother_education"
                      :required="form_relative_details.mother_education_sbpps"
                      :rules="
            form_relative_details.mother_education_sbpps
              ? [(v) => !!v || 'Education field is required']
              : []
          "
                      :clearable="form_relative_details.mother_education_sbpps ? false : true"
                      :prepend-icon="
            relative_mother_details.relative_education != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Qualification"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_occupation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_mother_details.relative_occupation"
                      name="mother_occupation"
                      :required="form_relative_details.mother_occupation_sbpps"
                      :rules="form_relative_details.mother_occupation_sbpps? [(v) => !!v || ' Occupation is required']: []"
                      counter
                      hint="Occupation"
                      persistent-hint
                      single-line
                      outlined
                      :prepend-icon="relative_mother_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"
                  ></v-text-field>

                  <!-- <v-autocomplete
          dense
          v-model="relative_mother_details.relative_occupation"
          :items="occupation_list"
          name="mother_occupation"
          :required="form_relative_details.relative_occupation"
          :rules="
            form_relative_details.relative_occupation
              ? [(v) => !!v || ' Occupation is required']
              : []
          "
          :clearable="
            form_relative_details.relative_occupation ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_mother_details.relative_occupation != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select Occupation"
          persistent-hint
        ></v-autocomplete> -->
              </v-col>
          </v-row>
        <v-row dense justify="center" v-if="relative_mother_details != null">
                      <v-col cols="10" sm="10" md="10">
                          <v-icon color="error" v-if="form_relative_details.mother_department_sbpps">*</v-icon>
                          <v-text-field
                              dense
                              v-model="relative_mother_details.relative_department"
                              name="mother_department"
                              :required="form_relative_details.mother_department_sbpps"
                              :rules="
                    form_relative_details.mother_department_sbpps
                      ? [(v) => !!v || 'Department is required']
                      : []
                  "
                              :clearable="
                    form_relative_details.mother_department_sbpps ? false : true
                  "
                              :prepend-icon="
                    relative_mother_details.relative_department != null
                      ? 'mdi-alpha-d-circle'
                      : 'mdi-alpha-d-circle-outline'
                  "
                              outlined
                              hint="Department"
                              persistent-hint
                          ></v-text-field>
                      </v-col>
                  </v-row>
          <!-- dept -->
          <v-row dense justify="center" v-if="relative_mother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_designation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_designation"
                      name="mother_designation"
                      :required="form_relative_details.mother_designation_sbpps"
                      :rules="
            form_relative_details.mother_designation_sbpps
              ? [(v) => !!v || 'Designation is required']
              : []
          "
                      :clearable="
            form_relative_details.mother_designation_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_designation != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Designation"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_mother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_organization_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_organization_name"
                      name="mother_organization_name"
                      :required="form_relative_details.mother_organization_name_sbpps"
                      :rules="
            form_relative_details.mother_organization_name_sbpps
              ? [(v) => !!v || 'Company/Organization name is required']
              : []
          "
                      :clearable="
            form_relative_details.mother_organization_name_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_organization_name != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Company/Organization"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_mother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_income_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_mother_details.relative_income"
                      name="mother_income"
                      type="number"
                      :required="form_relative_details.mother_income_sbpps"
                      :clearable="form_relative_details.mother_income_sbpps ? false : true"
                      :prepend-icon="
            relative_mother_details.relative_income != null
              ? 'mdi-alpha-c-circle'
              : 'mdi-alpha-c-circle-outline'
          "
                      outlined
                      hint="Annual Income"
                      persistent-hint
              
              </v-col>
          </v-row> -->
            <v-row dense justify="center" v-if="relative_father_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_income_range_sbpps">*</v-icon>
               <v-autocomplete
                      dense
                      :items="salaryRanges"
                      item-text="name"
                      v-model="relative_mother_details.relative_income_range"
                      name="mother_income_range"
                      :required="form_relative_details.mother_income_range_sbpps"
                      :clearable="form_relative_details.mother_income_range_sbpps ? false : true"
                      :prepend-icon="
                      relative_mother_details.relative_income_range != null
                        ? 'mdi-alpha-c-circle'
                        : 'mdi-alpha-c-circle-outline'
                    "
                      outlined
                      hint="Annual Income"
                      persistent-hint
                ></v-autocomplete>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_mother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_office_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_mother_details.relative_office_address"
                      :value="relative_mother_details.relative_office_address"
                      name="mother_office_address"
                      :required="form_relative_details.mother_office_address_sbpps"
                      :rules="
            form_relative_details.mother_office_address_sbpps
              ? [(v) => !!v || 'Company/Organization Address & Contact details is required']
              : []
          "
                      hint="Company/Organization Address & Contact details"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.mother_office_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_office_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="form_relative_details.mother_local_address_sbpps">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_local_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_mother_details.relative_local_address"
                      :value="relative_mother_details.relative_local_address"
                      name="mother_local_address"
                      :required="form_relative_details.mother_local_address_sbpps"
                      :rules="
            form_relative_details.mother_local_address_sbpps
              ? [(v) => !!v || 'Company/Organization Address & Contact details is required']
              : []
          "
                      hint="Local Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.mother_local_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_local_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="form_relative_details.mother_permanent_address_sbpps">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.mother_permanent_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_mother_details.relative_permanent_address"
                      :value="relative_mother_details.relative_permanent_address"
                      name="mother_permanent_address"
                      :required="form_relative_details.mother_permanent_address_sbpps"
                      :rules="
            form_relative_details.relative_permanent_address
              ? [(v) => !!v || 'Permanent Address']
              : []
          "
                      hint="Permanent Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.mother_permanent_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_mother_details.relative_permanent_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>

          <!-- ------ -->
          <!-- <v-row dense justify="center" v-if="relative_mother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_state"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_mother_details.relative_state"
          :items="state_list"
          name="mother_state"
          :required="form_relative_details.relative_state"
          :rules="
            form_relative_details.relative_state
              ? [(v) => !!v || ' State is required']
              : []
          "
          :clearable="
            form_relative_details.relative_state ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_mother_details.relative_state != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select State"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row>
     <v-row dense justify="center" v-if="relative_mother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_city"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_mother_details.relative_city"
          :items="cities_list"
          name="mother_city"
          :required="form_relative_details.relative_city"
          :rules="
            form_relative_details.relative_city
              ? [(v) => !!v || ' City is required']
              : []
          "
          :clearable="
            form_relative_details.relative_city ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_mother_details.relative_city != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select City"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row> -->

          

          <hr color="grey lighten-1" v-if="relative_brother_details" />
          <!-- End Mother Details --------------------------------------------->

          <!-- Brother Details --------------------------------------------->
          <input v-if="relative_brother_details" type="hidden" value="Brother" name="relation_type" />
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <h4>{{ relative_brother_details.field_display_name }}</h4>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_full_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_full_name"
                      name="brother_full_name"
                      :required="form_relative_details.brother_full_name_sbpps"
                      :rules="
            form_relative_details.brother_full_name_sbpps
              ? [(v) => !!v || 'Brother full name is required']
              : []
          "
                      :clearable="form_relative_details.brother_full_name_sbpps ? false : true"
                      :prepend-icon="
            relative_brother_details.relative_full_name != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Brother Full Name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_aadharno_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_aadharno"
                      name="brother_aadharno"
                      :required="form_relative_details.brother_aadharno_sbpps"
                      :rules="
                      form_relative_details.brother_aadharno_sbpps.required
                        ? [
                            v => !!v || 'Aadhaar No is required',
                            v =>
                              (v && v.length == 12) ||
                               'Aadhaar no must be 12 digit number'
                          ]
                        : [
                            v =>
                              (v == null || v == ''
                                ? true
                                : v.length == 0 || v.length == 12) ||
                              'Aadhaar no must be 12 digit number'
                          ]
                    "
                    counter
                    maxlength="12"
                      :clearable="form_relative_details.brother_aadharno_sbpps ? false : true"
                      :prepend-icon="
            relative_brother_details.relative_aadharno != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Brother Aadhaarno"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_brother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_citizenship"
          >*</v-icon
        >
        <v-text-field
          dense
          v-model="relative_brother_details.relative_citizenship"
          name="brother_citizenship"
          :required="form_relative_details.relative_citizenship"
          :rules="
            form_relative_details.relative_citizenship
              ? [(v) => !!v || 'Brother Citizenship is required']
              : []
          "
          :clearable="form_relative_details.relative_citizenship ? false : true"
          :prepend-icon="
            relative_brother_details.relative_citizenship != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
          outlined
          hint="Brother Citizenship"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row> -->
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_education_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_education"
                      name="brother_education"
                      :required="form_relative_details.brother_education_sbpps"
                      :rules="
            form_relative_details.brother_education_sbpps
              ? [(v) => !!v || 'Education field is required']
              : []
          "
                      :clearable="form_relative_details.brother_education_sbpps ? false : true"
                      :prepend-icon="
            relative_brother_details.relative_education != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Education Details"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_contact_no_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="number"
                      v-model="relative_brother_details.relative_contact_no"
                      name="brother_contact_no"
                      :required="form_relative_details.brother_contact_no_sbpps"
                      :rules="
            form_relative_details.brother_contact_no_sbpps
              ? [
                  (v) => !!v || 'Mobile Number is required',
                  (v) =>
                    (v && v.length == 10) || 'Mobile Number Must be 10 digit',
                ]
              : [
                  (v) =>
                    (v == null || v == ''
                      ? true
                      : v.length == 0 || v.length == 10) ||
                    'Mobile Mobile Number Must be 10 digit',
                ]
          "
                      counter
                      maxlength="10"
                      hint="Mobile no."
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.brother_contact_no_sbpps ? false : true
          "
                      :prepend-icon="
            relative_brother_details.relative_contact_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_email_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_brother_details.relative_email"
                      name="brother_email"
                      :required="form_relative_details.brother_email_sbpps"
                      :rules="
            form_relative_details.brother_email_sbpps
              ? [
                  (v) => !!v || 'Email is required',
                  (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                ]
              : [
                  (v) =>
                    v == null ||
                    v == '' ||
                    /.+@.+/.test(v) ||
                    'E-mail must be valid',
                ]
          "
                      counter
                      hint="Email"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="form_relative_details.brother_email_sbpps ? false : true"
                      :prepend-icon="
            relative_brother_details.relative_email != null
              ? 'mdi-contact-mail'
              : 'mdi-contact-mail-outline'
          "
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_occupation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="text"
                      v-model="relative_brother_details.relative_occupation"
                      name="brother_occupation"
                      :required="form_relative_details.brother_occupation_sbpps"
                      :rules="form_relative_details.brother_occupation_sbpps? [(v) => !!v || ' Occupation is required']: []"
                      counter
                      hint="Occupation"
                      persistent-hint
                      single-line
                      outlined
                      :prepend-icon="relative_brother_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"
                  ></v-text-field>
                  <!-- <v-autocomplete
          dense
          v-model="relative_brother_details.relative_occupation"
          :items="occupation_list"
          name="brother_occupation"
          :required="form_relative_details.relative_occupation"
          :rules="
            form_relative_details.relative_occupation
              ? [(v) => !!v || ' Occupation is required']
              : []
          "
          :clearable="
            form_relative_details.relative_occupation ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_brother_details.relative_occupation != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select Occupation"
          persistent-hint
        ></v-autocomplete> -->
              </v-col>
          </v-row>
            <v-row dense justify="center" v-if="relative_brother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_department_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_department"
                      name="brother_department"
                      :required="form_relative_details.brother_department_sbpps"
                      :rules="
            form_relative_details.brother_department_sbpps
              ? [(v) => !!v || 'Department is required']
              : []
          "
                      :clearable="
            form_relative_details.brother_department_sbpps ? false : true
          "
                      :prepend-icon="
            relative_brother_details.relative_department != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Department"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
           <v-row dense justify="center" v-if="relative_brother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_designation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_designation"
                      name="brother_designation"
                      :required="form_relative_details.brother_designation_sbpps"
                      :rules="
            form_relative_details.brother_designation_sbpps
              ? [(v) => !!v || 'Designation is required']
              : []
          "
                      :clearable="
            form_relative_details.brother_designation_sbpps ? false : true
          "
                      :prepend-icon="
            relative_brother_details.relative_designation != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Designation"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

        
          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_nationality_sbpps">*</v-icon>
                  <v-autocomplete
                      dense
                      v-model="relative_brother_details.relative_nationality"
                      :items="nationality_list"
                      name="brother_nationality"
                      :required="form_relative_details.brother_nationality_sbpps"
                      :rules="
            form_relative_details.brother_nationality_sbpps
              ? [(v) => !!v || ' Nationality is required']
              : []
          "
                      :clearable="
            form_relative_details.brother_nationality_sbpps ? false : true
          "
                      return-object
                      single-line
                      :prepend-icon="
            relative_brother_details.relative_nationality != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Select Nationality"
                      persistent-hint
                  ></v-autocomplete>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_brother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_state"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_brother_details.relative_state"
          :items="state_list"
          name="brother_state"
          :required="form_relative_details.relative_state"
          :rules="
            form_relative_details.relative_state
              ? [(v) => !!v || ' State is required']
              : []
          "
          :clearable="
            form_relative_details.relative_state ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_brother_details.relative_state != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select State"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row>
     <v-row dense justify="center" v-if="relative_brother_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_city"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_brother_details.relative_city"
          :items="cities_list"
          name="brother_city"
          :required="form_relative_details.relative_city"
          :rules="
            form_relative_details.relative_city
              ? [(v) => !!v || ' City is required']
              : []
          "
          :clearable="
            form_relative_details.relative_city ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_brother_details.relative_city != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select City"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row> -->

          <v-row dense justify="center" v-if="relative_brother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_organization_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_organization_name"
                      name="brother_organization_name"
                      :required="form_relative_details.brother_organization_name_sbpps"
                      :rules="
            form_relative_details.brother_organization_name_sbpps
              ? [(v) => !!v || 'Working Organization name is required']
              : []
          "
                      :clearable="
            form_relative_details.brother_organization_name_sbpps ? false : true
          "
                      :prepend-icon="
            relative_brother_details.relative_organization_name != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Working Organization name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_brother_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_income_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_brother_details.relative_income"
                      name="brother_income"
                      type="number"
                      :required="form_relative_details.brother_income_sbpps"
                      :clearable="form_relative_details.brother_income_sbpps ? false : true"
                      :prepend-icon="
            relative_brother_details.relative_income != null
              ? 'mdi-alpha-c-circle'
              : 'mdi-alpha-c-circle-outline'
          "
                      outlined
                      hint="Annual Income for example 800000"
                      persistent-hint
                  ></v-text-field>
                  <!-- :rules="
            form_relative_details.brother_income_sbpps
              ? [(v) => !!v || 'Annual income is required']
              : []
          " -->
              </v-col>
          </v-row>
         

          <v-row dense justify="center" v-if="relative_brother_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.brother_office_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_brother_details.relative_office_address"
                      :value="relative_brother_details.relative_office_address"
                      name="brother_office_address"
                      :required="form_relative_details.brother_office_address_sbpps"
                      :rules="
            form_relative_details.brother_office_address_sbpps
              ? [(v) => !!v || 'Office Address is required']
              : []
          "
                      hint="Office Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.brother_office_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_brother_details.relative_office_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>

          <hr color="grey lighten-1" v-if="relative_sister_details" />
          <!-- End of brother Details --------------------------------------------->

          <!-- Sister Details --------------------------------------------->
          <input v-if="relative_sister_details" type="hidden" value="Sister" name="relation_type" />
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <h4>{{ relative_sister_details.field_display_name }}</h4>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_full_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_full_name"
                      name="sister_full_name"
                      :required="form_relative_details.sister_full_name_sbpps"
                      :rules="
            form_relative_details.sister_full_name_sbpps
              ? [(v) => !!v || 'Sister full name is required']
              : []
          "
                      :clearable="form_relative_details.sister_full_name_sbpps ? false : true"
                      :prepend-icon="
            relative_sister_details.relative_full_name != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Sister Full Name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_aadharno_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_aadharno"
                      name="sister_aadharno"
                      :required="form_relative_details.sister_aadharno_sbpps"
                      :rules="
                      form_relative_details.sister_aadharno_sbpps.required
                        ? [
                            v => !!v || 'Aadhaar No is required',
                            v =>
                              (v && v.length == 12) ||
                               'Aadhaar no must be 12 digit number'
                          ]
                        : [
                            v =>
                              (v == null || v == ''
                                ? true
                                : v.length == 0 || v.length == 12) ||
                              'Aadhaar no must be 12 digit number'
                          ]
                    "
                    counter
                    maxlength="12"
                      :clearable="form_relative_details.sister_aadharno_sbpps ? false : true"
                      :prepend-icon="
            relative_sister_details.relative_aadharno != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Sister aadhaarno"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_sister_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_citizenship"
          >*</v-icon
        >
        <v-text-field
          dense
          v-model="relative_sister_details.relative_citizenship"
          name="sister_citizenship"
          :required="form_relative_details.relative_citizenship"
          :rules="
            form_relative_details.relative_citizenship
              ? [(v) => !!v || 'Sister Citizenship is required']
              : []
          "
          :clearable="form_relative_details.relative_citizenship ? false : true"
          :prepend-icon="
            relative_sister_details.relative_citizenship != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
          outlined
          hint="Sister Citizenship"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row> -->
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_education_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_education"
                      name="sister_education"
                      :required="form_relative_details.sister_education_sbpps"
                      :rules="
            form_relative_details.sister_education_sbpps
              ? [(v) => !!v || 'Education field is required']
              : []
          "
                      :clearable="form_relative_details.sister_education_sbpps ? false : true"
                      :prepend-icon="
            relative_sister_details.relative_education != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
          "
                      outlined
                      hint="Education Details"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_contact_no_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="number"
                      v-model="relative_sister_details.relative_contact_no"
                      name="sister_contact_no"
                      :required="form_relative_details.sister_contact_no_sbpps"
                      :rules="
            form_relative_details.sister_contact_no_sbpps
              ? [
                  (v) => !!v || 'Mobile Number is required',
                  (v) =>
                    (v && v.length == 10) || 'Mobile Number Must be 10 digit',
                ]
              : [
                  (v) =>
                    (v == null || v == ''
                      ? true
                      : v.length == 0 || v.length == 10) ||
                    'Mobile Mobile Number Must be 10 digit',
                ]
          "
                      counter
                      maxlength="10"
                      hint="Mobile no."
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.sister_contact_no_sbpps ? false : true
          "
                      :prepend-icon="
            relative_sister_details.relative_contact_no != null
              ? 'mdi-phone-classic'
              : 'mdi-phone-classic'
          "
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_email_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_sister_details.relative_email"
                      name="sister_email"
                      :required="form_relative_details.sister_email_sbpps"
                      :rules="
            form_relative_details.sister_email_sbpps
              ? [
                  (v) => !!v || 'Email is required',
                  (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                ]
              : [
                  (v) =>
                    v == null ||
                    v == '' ||
                    /.+@.+/.test(v) ||
                    'E-mail must be valid',
                ]
          "
                      counter
                      hint="Email"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="form_relative_details.sister_email_sbpps ? false : true"
                      :prepend-icon="
            relative_sister_details.relative_email != null
              ? 'mdi-contact-mail'
              : 'mdi-contact-mail-outline'
          "
                  ></v-text-field>
              </v-col>
          </v-row>


          
          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_nationality_sbpps">*</v-icon>
                  <v-autocomplete
                      dense
                      v-model="relative_sister_details.relative_nationality"
                      :items="nationality_list"
                      name="sister_nationality"
                      :required="form_relative_details.sister_nationality_sbpps"
                      :rules="
            form_relative_details.sister_nationality_sbpps
              ? [(v) => !!v || ' Nationality is required']
              : []
          "
                      :clearable="
            form_relative_details.sister_nationality_sbpps ? false : true
          "
                      return-object
                      single-line
                      :prepend-icon="
            relative_sister_details.relative_nationality != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Select Nationality"
                      persistent-hint
                  ></v-autocomplete>
              </v-col>
          </v-row>
          <!-- <v-row dense justify="center" v-if="relative_sister_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_state"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_sister_details.relative_state"
          :items="state_list"
          name="sister_state"
          :required="form_relative_details.relative_state"
          :rules="
            form_relative_details.relative_state
              ? [(v) => !!v || ' State is required']
              : []
          "
          :clearable="
            form_relative_details.relative_state ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_sister_details.relative_state != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select State"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row>
     <v-row dense justify="center" v-if="relative_sister_details">
      <v-col cols="10" sm="10" md="10">
        <v-icon color="error" v-if="form_relative_details.relative_city"
          >*</v-icon
        >
        <v-autocomplete
          dense
          v-model="relative_sister_details.relative_city"
          :items="cities_list"
          name="sister_city"
          :required="form_relative_details.relative_city"
          :rules="
            form_relative_details.relative_city
              ? [(v) => !!v || ' City is required']
              : []
          "
          :clearable="
            form_relative_details.relative_city ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_sister_details.relative_city != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select City"
          persistent-hint
        ></v-autocomplete>
      </v-col>
    </v-row> -->

          <v-row dense justify="center" v-if="relative_sister_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_organization_name_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_organization_name"
                      name="sister_organization_name"
                      :required="form_relative_details.relative_organization_name"
                      :rules="
            form_relative_details.sister_organization_name_sbpps
              ? [(v) => !!v || 'Working Organization name is required']
              : []
          "
                      :clearable="
            form_relative_details.sister_organization_name_sbpps ? false : true
          "
                      :prepend-icon="
            relative_sister_details.relative_organization_name != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
                      outlined
                      hint="Working Organization name"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          <v-row dense justify="center" v-if="relative_sister_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_income_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_income"
                      name="sister_income"
                      type="number"
                      :required="form_relative_details.sister_income_sbpps"
                      :clearable="form_relative_details.sister_income_sbpps ? false : true"
                      :prepend-icon="
            relative_sister_details.relative_income != null
              ? 'mdi-alpha-c-circle'
              : 'mdi-alpha-c-circle-outline'
          "
                      outlined
                      hint="Annual Income for example 800000"
                      persistent-hint
                  ></v-text-field>
                  <!-- :rules="
            form_relative_details.sister_income_sbpps
              ? [(v) => !!v || 'Annual income is required']
              : []
          " -->
              </v-col>
          </v-row>
<v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_occupation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      type="email"
                      v-model="relative_sister_details.relative_occupation"
                      name="sister_occupation"
                      :required="form_relative_details.sister_occupation_sbpps"
                      :rules="form_relative_details.sister_occupation_sbpps? [(v) => !!v || ' Occupation is required']: []"
                      counter
                      hint="Select Occupation"
                      persistent-hint
                      single-line
                      outlined
                      :prepend-icon="relative_sister_details.relative_occupation != null? 'mdi-alpha-o-circle': 'mdi-alpha-o-circle-outline'"
                  ></v-text-field>

                  <!-- <v-autocomplete
          dense
          v-model="relative_sister_details.relative_occupation"
          :items="occupation_list"
          name="sister_occupation"
          :required="form_relative_details.relative_occupation"
          :rules="
            form_relative_details.relative_occupation
              ? [(v) => !!v || ' Occupation is required']
              : []
          "
          :clearable="
            form_relative_details.relative_occupation ? false : true
          "
          return-object
          single-line
          :prepend-icon="
            relative_sister_details.relative_occupation != null
              ? 'mdi-alpha-o-circle'
              : 'mdi-alpha-o-circle-outline'
          "
          outlined
          hint="Select Occupation"
          persistent-hint
        ></v-autocomplete> -->
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_sister_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_department_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_department"
                      name="sister_department"
                      :required="form_relative_details.sister_department_sbpps"
                      :rules="
            form_relative_details.sister_department_sbpps
              ? [(v) => !!v || 'Department is required']
              : []
          "
                      :clearable="
            form_relative_details.sister_department_sbpps ? false : true
          "
                      :prepend-icon="
            relative_sister_details.relative_department != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Department"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>
          <v-row dense justify="center" v-if="relative_sister_details != null">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_designation_sbpps">*</v-icon>
                  <v-text-field
                      dense
                      v-model="relative_sister_details.relative_designation"
                      name="sister_designation"
                      :required="form_relative_details.sister_designation_sbpps"
                      :rules="
            form_relative_details.sister_designation_sbpps
              ? [(v) => !!v || 'Designation is required']
              : []
          "
                      :clearable="
            form_relative_details.sister_designation_sbpps ? false : true
          "
                      :prepend-icon="
            relative_sister_details.relative_designation != null
              ? 'mdi-alpha-d-circle'
              : 'mdi-alpha-d-circle-outline'
          "
                      outlined
                      hint="Designation"
                      persistent-hint
                  ></v-text-field>
              </v-col>
          </v-row>

          

          <v-row dense justify="center" v-if="relative_sister_details">
              <v-col cols="10" sm="10" md="10">
                  <v-icon color="error" v-if="form_relative_details.sister_office_address_sbpps">*</v-icon>
                  <v-textarea
                      dense
                      clear-icon="cancel"
                      v-model="relative_sister_details.relative_office_address"
                      :value="relative_sister_details.relative_office_address"
                      name="sister_office_address"
                      :required="form_relative_details.sister_office_address_sbpps"
                      :rules="
            form_relative_details.sister_office_address_sbpps
              ? [(v) => !!v || 'Office Address is required']
              : []
          "
                      hint="Office Address"
                      persistent-hint
                      single-line
                      outlined
                      :clearable="
            form_relative_details.sister_office_address_sbpps ? false : true
          "
                      :prepend-icon="
            relative_sister_details.relative_office_address != null
              ? 'mdi-home-circle'
              : 'mdi-home-circle-outline'
          "
                  ></v-textarea>
              </v-col>
          </v-row>
          <!-- End of Sister Details --------------------------------------------->

          <v-card v-if="form_siblings_details">
              <v-card-title> Sibling Details </v-card-title>
              <v-card-text>
                  <v-col cols="12">
                      <v-row v-if="sibling1!=null">
                          <input type="hidden" name="sib1_id" :value="sibling1.sib_id" />
                          <v-col cols="12" sm="3" md="3">
                              <v-text-field prepend-icon="mdi-numeric-1-circle-outline" dense v-model.trim="sibling1.sibling_name" name="sib1_name" outlined hint="Name" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3">
                              <v-text-field dense v-model.trim="sibling1.name_of_school" name="sib1_school_name" outlined hint="School Name" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" v-if="tenant=='uwws'">
                              <v-text-field dense type="number" v-model.trim="sibling1.age" name="sib1_age" outlined hint="Age" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-text-field dense v-model.trim="sibling1.date_of_birth" name="sib1_dob" outlined hint="DOB (DD/MM/YYYY)" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-autocomplete dense v-model="sibling1.relationtype" :items="relationtype_list" name="sib1_relation" single-line outlined hint="Relationship with the child" persistent-hint></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-autocomplete dense v-model="sibling1.standard" :items="standard_list" name="sib1_standard" single-line outlined hint="Grade" persistent-hint></v-autocomplete>
                          </v-col>
                      </v-row>
                      <v-row v-if="sibling2!=null">
                          <input type="hidden" name="sib2_id" :value="sibling2.sib_id" />
                          <v-col cols="12" sm="3" md="3">
                              <v-text-field dense v-model.trim="sibling2.sibling_name" name="sib2_name" outlined hint="Name" prepend-icon="mdi-numeric-2-circle-outline" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3">
                              <v-text-field dense v-model.trim="sibling2.name_of_school" name="sib2_school_name" outlined hint="School Name" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" v-if="tenant=='uwws'">
                              <v-text-field dense type="number" v-model.trim="sibling2.age" name="sib2_age" outlined hint="Age" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-text-field dense v-model.trim="sibling2.date_of_birth" name="sib2_dob" outlined hint="DOB (DD/MM/YYYY)" persistent-hint></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-autocomplete dense v-model="sibling2.relationtype" :items="relationtype_list" name="sib2_relation" single-line outlined hint="Relationship with the child" persistent-hint></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="2" md="2" v-if="tenant!='uwws'">
                              <v-autocomplete dense v-model="sibling2.standard" :items="standard_list" name="sib2_standard" single-line outlined hint="Grade" persistent-hint></v-autocomplete>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12"> </v-col>
                      </v-row>
                  </v-col>
              </v-card-text>
          </v-card>

          <v-row justify="center" dense>
              <v-col cols="10" sm="10" md="10"> </v-col>
          </v-row>

          <v-row justify="center" dense>
              <v-col cols="10" sm="10" md="10">
                  <div style="text-align: center;">
                      <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit" :disabled="!isValid">Save</v-btn>
                  </div>
              </v-col>
          </v-row>
      </v-form>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
      data() {
          return {
            salaryRanges: [
                { id: '1', name: '0' },
                { id: '2', name: 'Below 5 Lakh' },
                { id: '3', name: '5.1 to 10 lakh' },
                { id: '4', name: '10.1 to 15 lakh' },
                { id: '5', name: 'Above 15 Lakh' }
              ],
              isValid: true,
              loader: false,
              snackbar_msg: "",
              color: "",
              snackbar: false,
              application_form_data: {
                  admission_form_no: "",
                  admission_form_id: "",
                  display_admission_form_no: ""
              },
              relative_father_details: null,
              relative_mother_details: null,
              relative_brother_details: null,
              relative_sister_details: null,
              form_relative_details: null,
              occupation_list: null,
              state_list: null,
              cities_list: null,
              form_who_takes_pupil_studies: null,
              who_takes_pupil_studies: null,
              sibling1: null,
              sibling2: null,
              form_siblings_details: null,
              relationtype_list: ["Brother", "Sister"],
              standard_list: [],
              tenant: "wws",
          };
      },
      created() {
          this.tenant = localStorage.getItem("EPS-tenant");
      },
      methods: {
          submit: function (e) {
              this.loader = false;
              var form = document.getElementById("familydetails_form");
              var formData = new FormData(form);
              axios.post("/admissionForm/saveRelatives", formData).then(
                  (response) => {
                      // success callback

                      if (response.data.form_saved == "YES") {
                          this.showSnackbar("#4caf50", "Saved Successfully...Click on Next Tab To Continue"); // show snackbar on success
                      }
                      this.loader = true;
                      this.$store.commit("setform_progress", response.data.form_progress);
                      this.getform();
                  },
                  (response) => {
                      // error callback
                  }
              );
          },
          getform() {
              axios
                  .post("/admissionForm/familyDetailsSBPPS", this.application_form_data)
                  .then((res) => {
                      if (res.data.msg == "200") {
                          this.relative_father_details = res.data.relative_father_details;
                          this.relative_mother_details = res.data.relative_mother_details;
                          this.relative_brother_details = res.data.relative_brother_details;
                          this.relative_sister_details = res.data.relative_sister_details;
                          this.form_relative_details = res.data.form_relative_details;
                          this.occupation_list = res.data.occupation_list;
                          this.nationality_list = res.data.nationality_list;
                          this.form_who_takes_pupil_studies = res.data.form_who_takes_pupil_studies;
                          this.who_takes_pupil_studies = res.data.who_takes_pupil_studies;
                          this.form_siblings_details = res.data.form_siblings_details;
                          this.sibling1 = res.data.sibling1;
                          this.sibling2 = res.data.sibling2;
                          this.standard_list = res.data.standard_list;
                          //this.relationtype_list = res.data.relationtype_list
                          this.loader = true;
                          //by mayur
                          this.state_list = res.data.states_list;
                          this.cities_list = res.data.cities_list;
                          //by mayur

                          this.$store.commit("setform_progress", res.data.form_progress);
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },
      mounted() {
          this.application_form_data = this.$store.getters.application_form_data;
          this.getform();
      },
  };
</script>
